import { KeyboardShortcut, PointCloudRenderer } from 'features/pointClouds'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

const InfoText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: white;
  z-index: 1000;
`

// ----------------------------------------------------------------------------

export const PointCloudWrapper = () => {
  const [showPointCloudRenderer, setShowPointCloudRenderer] = useState(true)

  useEffect(() => {
    const keyListener = (event: KeyboardEvent) => {
      if (event.key === KeyboardShortcut.TOGGLE_POINT_CLOUD_RENDERER) {
        setShowPointCloudRenderer(!showPointCloudRenderer)
      }
    }
    window.addEventListener('keydown', keyListener)
    return () => window.removeEventListener('keydown', keyListener)
  }, [showPointCloudRenderer, setShowPointCloudRenderer])

  return (
    <>
      {showPointCloudRenderer && <PointCloudRenderer />}
      {!showPointCloudRenderer && (
        <InfoText>
          Press &apos;\&apos; to re-enable the point cloud renderer
        </InfoText>
      )}
    </>
  )
}
